<script setup lang="ts">
import { ref } from "vue";

import AppMenuItem from "./AppMenuItem.vue";
import { crudRoutes } from "src/router/crud-routes";

interface MenuItem {
  label: string;
  icon?: string;
  to?: string;
  items?: MenuItem[];
  separator?: boolean;
}

const crudRoutesWithoutDetailRoutes = crudRoutes.filter((route) => !route.path.includes(":id"));

const model = ref<MenuItem[]>([
  {
    label: "",
    items: [
      // { label: "Dashboard", icon: "pi pi-fw pi-home", to: "/" },
      { label: "Ticket board", icon: "pi pi-fw pi-th-large", to: "/ticket-board" },
      { label: "Ready for processing", icon: "pi pi-fw pi-check-square", to: "/ready-for-processing" },
      { label: "Recipe management", icon: "pi pi-fw pi-book", to: "/recipe-management" },
      { label: "Article management", icon: "pi pi-fw pi-box", to: "/article-management" },
      { label: "Contract management", icon: "pi pi-fw pi-file", to: "/contract-management" },
      ...crudRoutesWithoutDetailRoutes.map((route) => ({
        label: route.name?.toString() ?? "",
        to: route.path,
        icon: "pi pi-fw pi-file",
      })),
    ],
  },
]);
</script>

<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="item">
      <app-menu-item v-if="!item.separator" :item="item" :index="i"></app-menu-item>
      <li v-if="item.separator" class="menu-separator"></li>
    </template>
  </ul>
</template>

<style lang="scss" scoped></style>
